/* eslint-disable no-console */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomInput from "../../../../Core/Components/CustomInput";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import RangePicker from "../../RangePicker";
import { DRIVER_OPERATION_TYPE } from "./data";
import { PAYMENT_STATUS } from "../../data";
import getPaymentStatus from "../../getPaymentStatus";
import Button from "../../../../Core/Components/CustomButton";
import useHeaderButtons from "./useHeaderButtons";

const DriverDetailHeader = ({
  search,
  setSearch,
  filters,
  setFilters,
  // setCurrentPage,
  selectedTab,
  setSelectedTab,
  setHistoryDrawer,
}) => {
  const { selectedPayment } = useSelector((state) => state.revenue);

  const [focus, setFocus] = useState(false);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);

  const headerButtons = useHeaderButtons().filter((item) => item.hasPermission);

  const onDateRangeSelect = (e) => {
    // clear the date range and close the the date range input box
    if (filters.dateRangeStart !== "" && filters.dateRangeEnd !== "") {
      setFilters((prev) => ({
        ...prev,
        dateRangeStart: "",
        dateRangeEnd: "",
      }));

      setDateRangeOpen(false);
    }
    // set the start date and end date
    else {
      const [startMonth, endMonth] = e;

      setFilters((prev) => ({
        ...prev,
        dateRangeStart: startMonth,
        dateRangeEnd: endMonth,
      }));
    }
  };

  const getPaymentStatusTag = () => {
    // if amount exists only then show the tag
    if (
      (parseFloat(selectedPayment?.totalAmountDue) !== 0 &&
        selectedPayment.paymentStatus === PAYMENT_STATUS.PENDING) ||
      (parseFloat(selectedPayment?.totalAmountPaid) !== 0 &&
        selectedPayment.paymentStatus === PAYMENT_STATUS.COMPLETED)
    ) {
      const status =
        selectedPayment?.totalAmountDue === selectedPayment.totalAmountPaid
          ? PAYMENT_STATUS.COMPLETED
          : PAYMENT_STATUS.PENDING;

      return <div className="max-w-max">{getPaymentStatus(status)}</div>;
    }

    return null;
  };

  return (
    <div className="bg-background-white">
      <div className="px-6 py-2.5 flex items-center justify-between border-y-[0.5px] border-light-grey">
        <div className="flex items-center gap-x-6">
          {headerButtons.map((item) => {
            const selected = selectedTab === item.id;

            return (
              <Button
                key={item.id}
                colors={selected ? "primary" : "white"}
                width={item.width}
                padding={item.padding}
                modifier="shadow"
                onClick={() => setSelectedTab(item.id)}
              >
                <div>{item.text}</div>
              </Button>
            );
          })}
        </div>

        <div className="flex items-center">
          <div className="flex items-center gap-x-3">
            <CustomInput
              intent="search"
              prefix={
                <img src="/assets/icons/search.svg" alt="" className="mr-2" />
              }
              value={search}
              focus={focus}
              border={focus ? "success" : "none"}
              placeholder={(() => {
                if (focus) return null;
                if (selectedTab === DRIVER_OPERATION_TYPE.TRIP)
                  return "Search Trip ID";
                if (selectedTab === DRIVER_OPERATION_TYPE.SESSION)
                  return "Search Session ID";
                return "";
              })()}
              onChange={(e) => setSearch(e.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              suffix={
                search.length > 0 ? (
                  <CloseIcon
                    className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                    onClick={() => {
                      setFocus(false);
                      setSearch("");
                    }}
                  />
                ) : null
              }
            />

            <RangePicker
              dateRangeOpen={dateRangeOpen}
              setDateRangeOpen={setDateRangeOpen}
              onChange={onDateRangeSelect}
              startDate={filters.dateRangeStart}
              endDate={filters.dateRangeEnd}
            />

            {getPaymentStatusTag()}

            <button
              type="button"
              className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
              onClick={() => setHistoryDrawer(true)}
            >
              <div className="flex item-center gap-x-2">
                <img
                  src="/assets/icons/receipt.svg"
                  className="w-4 h-4"
                  alt="transaction-history"
                />

                <p className="font-poppins text-xs leading-4.5 font-medium text-background-white">
                  Transaction History
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverDetailHeader;
